<template>
  <v-container fill-height fluid>
    <v-layout pt-5 mt-5 row>
      <v-flex sm10 offset-sm1>
        <v-card class="elevation-0">
          <v-card-title primary-title class="primary--text">
            <h3 class="display-1 mb-0 ml-3">{{ 'shopcart.title' | t }}</h3>
          </v-card-title>
          <v-card-text v-if="loaders">
            <v-flex text-md-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-flex>
          </v-card-text>
          <v-card-text v-else>
            <v-layout justify-space-around align-center row>
              <v-flex v-if="product_set_description !== ''" md6>
                <v-card class="elevation-2 pa-2" color="grey lighten-1">
                  <v-card-title>
                    <span class="headline">{{orderData.product_type}}</span>
                  </v-card-title>
                  <v-card-text class="ml-5">
                    <p class="subheading">{{ product_set_description[$i18n.locale][1] }}</p>
                    <p class="subheading mt-3">{{ product_set_description[$i18n.locale][2] }}</p>
                    <p class="subheading mt-3">{{ product_set_description[$i18n.locale][3] }}</p>
                    <p class="subheading mt-3">{{ product_set_description[$i18n.locale][4] }}</p>
                    <p class="subheading mt-3">{{ product_set_description[$i18n.locale][5] }}</p>
                  </v-card-text>
                  <v-card-text>
                    <span
                      class="subheading mt-3"
                    >{{ 'shopcart.request' | t }}: {{ orderData.product_requests | formatnumber }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex md4>
                <v-layout row>
                  <v-flex>
                    <v-card class="pa-2" color="blue-grey lighten-4">
                      <h3 class="ma-1">{{ orderData.firstname }} {{ orderData.lastname }}</h3>
                      <p v-if="orderData.company !== ''" class="ma-1">{{ orderData.company }}</p>
                      <p class="ma-1">{{ orderData.id_card }}</p>
                      <p class="ma-1">{{ orderData.address }}</p>
                      <p class="ma-1">{{ orderData.postal_code }}, {{ orderData.city }}</p>
                      <p class="ma-1">{{ orderData.country_name }}</p>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex pt-4>
                    <v-card class="pa-2" color="blue-grey lighten-4">
                      <p class="ma-1 text-md-right">Discount: {{ orderData.discount }} %</p>
                      <p
                        class="ma-1 text-md-right"
                      >Baseprice: {{ orderData.base_price | currency }} &euro;</p>
                      <p
                        v-if="orderData.vat_valid === 0"
                        class="ma-1 text-md-right"
                      >Taxes: {{ orderData.taxes }} %</p>
                      <p v-else class="ma-1 text-md-right">VAT Non-Taxable</p>
                      <p
                        class="ma-1 text-md-right"
                      >Total Price: {{ orderData.total_price | currency }} &euro;</p>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex text-md-right>
                <v-form
                  method="post"
                  action="https://sis.redsys.es/sis/realizarPago"
                  ref="nativeForm"
                >
                  <input type="hidden" name="Ds_SignatureVersion" :value="form.Ds_SignatureVersion">
                  <input
                    type="hidden"
                    name="Ds_MerchantParameters"
                    :value="form.Ds_MerchantParameters"
                  >
                  <input type="hidden" name="Ds_Signature" :value="form.Ds_Signature">
                  <v-btn dark class="primary" to="/shop">{{ 'shopcart.cancel' | t }}</v-btn>
                  <v-btn
                    dark
                    class="primary"
                    @click="payNow"
                    :disabled="formdisable"
                  >{{ 'shopcart.checkout' | t }}</v-btn>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      loaders: true,
      order_id: 0,
      product_set_description: "",
      orderData: {
        user: 0,
        consumer: 0,
        product: 0,
        product_set: 0,
        billing_date: new Date(),
        firstname: "",
        lastname: "",
        company: "",
        address: "",
        postal_code: "",
        city: "",
        country: "",
        country_name: "",
        id_card: "",
        product_name: "",
        product_description: "",
        product_requests: "",
        product_type: "",
        product_set_description: "",
        price: 0,
        discount: "",
        base_price: 0,
        vat_valid: 0,
        taxes: 0,
        total_price: 0
      },
      formdisable: true,
      form: {
        Ds_SignatureVersion: "",
        Ds_MerchantParameters: "",
        Ds_Signature: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getServer", "getTokenHeader", "getProduct", "getUserType"])
  },
  created() {
    if (this.getUserType) this.getAdHoc();
    else this.getOrder();
  },
  methods: {
    ...mapActions(["rmKey"]),
    payNow() {
      this.$refs.nativeForm.$el.submit();
    },
    getOrder() {
      this.$http
        .post(
          `${this.getServer}/orders/web`,
          { product_id: this.getProduct },
          this.getTokenHeader
        )
        .then(response => {
          if (response.data.error) {
            this.$router.push({ path: "/shop" });
          } else {
            this.order_id = response.data.order_id;
            this.form = response.data.form;
            this.orderData = response.data.orderData;
            this.product_set_description = JSON.parse(
              response.data.orderData.product_set_description
            );
            this.formdisable = false;
            this.loaders = false;
          }
        })
        .catch(() => {
          this.$router.push({ path: "/shop" });
        });
    },
    getAdHoc() {
      this.$http
        .get(`${this.getServer}/orders/adhoc`, this.getTokenHeader)
        .then(response => {
          if (response.data.error) {
            this.$router.push({ path: "/shop" });
          } else {
            this.order_id = response.data.order_id;
            this.form = response.data.form;
            this.orderData = response.data.orderData;
            this.formdisable = false;
            this.loaders = false;
          }
        })
        .catch(() => {
          this.$router.push({ path: "/shop" });
        });
    }
  }
};
</script>